import {useState, useEffect, FC} from 'react'
import {Container} from 'react-bootstrap'
import {privacity} from '../../../_metronic/helpers/catalogs/privacity'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

type Language = 'en' | 'es' | 'fr' | 'pt'

const PrivacyPage: FC = () => {
  const [language, setLanguage] = useState<Language>('en')
  const t = privacity[language]

  // Efecto para aplicar estilos al montar el componente
  useEffect(() => {
    // Agregar padding-top al container para compensar la barra fija
    const container = document.querySelector('.privacy-container')
    if (container) {
      ;(container as HTMLElement).style.paddingTop = '100px'
    }
  }, [])

  // Manejador para cambiar el idioma con soporte para teclado
  const handleLanguageChange = (lang: 'en' | 'es' | 'fr' | 'pt') => {
    setLanguage(lang)
  }

  // Manejador para eventos de teclado
  const handleKeyDown = (e: React.KeyboardEvent, lang: 'en' | 'es' | 'fr' | 'pt') => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleLanguageChange(lang)
    }
  }

  return (
    <>
      {/* Contenedor principal para mantener el mismo ancho que Container */}
      <div className='container'>
        {/* Barra de idiomas fija */}
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            backgroundColor: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            padding: '10px 0',
            zIndex: 1000,
          }}
        >
          {/* Contenedor interno alineado con el Container de Bootstrap */}
          <div
            className='container'
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0', // Eliminar padding adicional
            }}
          >
            {/* Logo que redirecciona a paneltrackstore.com */}
            <a
              href='https://paneltrackstore.com'
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
              aria-label='Panel Track Store'
            >
              <img
                src={toAbsoluteUrl('/media/logos/default-small-dark.svg')}
                alt='Panel Track Logo'
                style={{
                  height: '40px',
                  width: 'auto',
                }}
              />
            </a>

            {/* Botones de idioma */}
            <div
              style={{display: 'flex', gap: '20px'}}
              role='toolbar'
              aria-label='Language selection'
            >
              <button
                onClick={() => handleLanguageChange('en')}
                onKeyDown={(e) => handleKeyDown(e, 'en')}
                aria-pressed={language === 'en'}
                aria-label='English'
                style={{
                  cursor: 'pointer',
                  opacity: language === 'en' ? 1 : 0.6,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  borderBottom: language === 'en' ? '2px solid #0d6efd' : 'none',
                  background: 'none',
                  border: 'none',
                  padding: '5px 10px',
                }}
              >
                <span style={{fontSize: '24px'}} aria-hidden='true'>
                  EN
                </span>
                <span style={{fontSize: '12px', marginTop: '3px'}}>English</span>
              </button>
              <button
                onClick={() => handleLanguageChange('es')}
                onKeyDown={(e) => handleKeyDown(e, 'es')}
                aria-pressed={language === 'es'}
                aria-label='Español'
                style={{
                  cursor: 'pointer',
                  opacity: language === 'es' ? 1 : 0.6,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  borderBottom: language === 'es' ? '2px solid #0d6efd' : 'none',
                  background: 'none',
                  border: 'none',
                  padding: '5px 10px',
                }}
              >
                <span style={{fontSize: '24px'}} aria-hidden='true'>
                  ES
                </span>
                <span style={{fontSize: '12px', marginTop: '3px'}}>Español</span>
              </button>
              <button
                onClick={() => handleLanguageChange('fr')}
                onKeyDown={(e) => handleKeyDown(e, 'fr')}
                aria-pressed={language === 'fr'}
                aria-label='Français'
                style={{
                  cursor: 'pointer',
                  opacity: language === 'fr' ? 1 : 0.6,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  borderBottom: language === 'fr' ? '2px solid #0d6efd' : 'none',
                  background: 'none',
                  border: 'none',
                  padding: '5px 10px',
                }}
              >
                <span style={{fontSize: '24px'}} aria-hidden='true'>
                  FR
                </span>
                <span style={{fontSize: '12px', marginTop: '3px'}}>Français</span>
              </button>
              <button
                onClick={() => handleLanguageChange('pt')}
                onKeyDown={(e) => handleKeyDown(e, 'pt')}
                aria-pressed={language === 'pt'}
                aria-label='Português'
                style={{
                  cursor: 'pointer',
                  opacity: language === 'pt' ? 1 : 0.6,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  borderBottom: language === 'pt' ? '2px solid #0d6efd' : 'none',
                  background: 'none',
                  border: 'none',
                  padding: '5px 10px',
                }}
              >
                <span style={{fontSize: '24px'}} aria-hidden='true'>
                  PR
                </span>
                <span style={{fontSize: '12px', marginTop: '3px'}}>Português</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Contenido de la política de privacidad */}
      <Container className='privacy-container'>
        {/* Title and Introduction */}
        <h1>{t.privacy_policy.title}</h1>
        <p>{t.privacy_policy.effective_date}</p>
        <p>{t.privacy_policy.intro.company}</p>
        <p>{t.privacy_policy.intro.explanation}</p>
        <p>{t.privacy_policy.intro.agreement}</p>

        <hr style={{border: 'none', borderTop: '1px solid #999', margin: '40px auto'}} />

        {/* Information Collection */}
        <h2>{t.privacy_policy.information_collection.title}</h2>
        <p>{t.privacy_policy.information_collection.description}</p>

        <hr style={{border: 'none', borderTop: '1px solid #999', margin: '40px auto'}} />

        {/* Types of Data */}
        <h2>{t.privacy_policy.types_of_data.title}</h2>

        {/* Personal Data */}
        <h3>{t.privacy_policy.types_of_data.personal_data.title}</h3>
        <p>{t.privacy_policy.types_of_data.personal_data.description}</p>
        <ul>
          {t.privacy_policy.types_of_data.personal_data.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        {/* Usage Data */}
        <h3>{t.privacy_policy.types_of_data.usage_data.title}</h3>
        <p>{t.privacy_policy.types_of_data.usage_data.description_browser}</p>
        <p>{t.privacy_policy.types_of_data.usage_data.description_mobile}</p>

        {/* Tracking & Cookies */}
        <h3>{t.privacy_policy.types_of_data.tracking_cookies.title}</h3>
        <p>{t.privacy_policy.types_of_data.tracking_cookies.description}</p>
        <p>{t.privacy_policy.types_of_data.tracking_cookies.explanation}</p>
        <p>{t.privacy_policy.types_of_data.tracking_cookies.browser_instructions}</p>
        <p>Examples of Cookies we use:</p>
        <ul>
          <li>
            <strong>
              {t.privacy_policy.types_of_data.tracking_cookies.cookie_types.session.title}.
            </strong>{' '}
            {t.privacy_policy.types_of_data.tracking_cookies.cookie_types.session.description}
          </li>
          <li>
            <strong>
              {t.privacy_policy.types_of_data.tracking_cookies.cookie_types.preference.title}.
            </strong>{' '}
            {t.privacy_policy.types_of_data.tracking_cookies.cookie_types.preference.description}
          </li>
          <li>
            <strong>
              {t.privacy_policy.types_of_data.tracking_cookies.cookie_types.security.title}.
            </strong>{' '}
            {t.privacy_policy.types_of_data.tracking_cookies.cookie_types.security.description}
          </li>
        </ul>

        <hr style={{border: 'none', borderTop: '1px solid #999', margin: '40px auto'}} />

        {/* Use of Data */}
        <h2>{t.privacy_policy.use_of_data.title}</h2>
        <p>Panel Track LLC uses the collected data for various purposes:</p>
        <ul>
          {t.privacy_policy.use_of_data.purposes.map((purpose) => (
            <li key={purpose}>{purpose}</li>
          ))}
        </ul>

        <hr style={{border: 'none', borderTop: '1px solid #999', margin: '40px auto'}} />

        {/* Transfer of Data */}
        <h2>{t.privacy_policy.transfer_of_data.title}</h2>
        <p>{t.privacy_policy.transfer_of_data.description}</p>
        <p>{t.privacy_policy.transfer_of_data.international}</p>
        <p>{t.privacy_policy.transfer_of_data.consent}</p>
        <p>{t.privacy_policy.transfer_of_data.security}</p>

        <hr style={{border: 'none', borderTop: '1px solid #999', margin: '40px auto'}} />

        {/* Disclosure of Data */}
        <h2>{t.privacy_policy.disclosure_of_data.title}</h2>
        <h3>{t.privacy_policy.disclosure_of_data.legal_requirements.title}</h3>
        <p>{t.privacy_policy.disclosure_of_data.legal_requirements.description}</p>
        <ul>
          {t.privacy_policy.disclosure_of_data.legal_requirements.reasons.map((reason) => (
            <li key={reason}>{reason}</li>
          ))}
        </ul>

        <hr style={{border: 'none', borderTop: '1px solid #999', margin: '40px auto'}} />

        {/* Security of Data */}
        <h2>{t.privacy_policy.security_of_data.title}</h2>
        <p>{t.privacy_policy.security_of_data.description}</p>

        <hr style={{border: 'none', borderTop: '1px solid #999', margin: '40px auto'}} />

        {/* Service Providers */}
        <h2>{t.privacy_policy.service_providers.title}</h2>
        <p>{t.privacy_policy.service_providers.description}</p>
        <p>{t.privacy_policy.service_providers.obligations}</p>

        <hr style={{border: 'none', borderTop: '1px solid #999', margin: '40px auto'}} />

        {/* Links to Other Sites */}
        <h2>{t.privacy_policy.links_to_other_sites.title}</h2>
        <p>{t.privacy_policy.links_to_other_sites.description}</p>
        <p>{t.privacy_policy.links_to_other_sites.disclaimer}</p>

        <hr style={{border: 'none', borderTop: '1px solid #999', margin: '40px auto'}} />

        {/* Children's Privacy */}
        <h2>{t.privacy_policy.childrens_privacy.title}</h2>
        <p>{t.privacy_policy.childrens_privacy.description}</p>
        <p>{t.privacy_policy.childrens_privacy.parental_notice}</p>

        <hr style={{border: 'none', borderTop: '1px solid #999', margin: '40px auto'}} />

        {/* Changes to Policy */}
        <h2>{t.privacy_policy.changes_to_policy.title}</h2>
        <p>{t.privacy_policy.changes_to_policy.notification}</p>
        <p>{t.privacy_policy.changes_to_policy.effective_date}</p>
        <p>{t.privacy_policy.changes_to_policy.review_advice}</p>

        <hr style={{border: 'none', borderTop: '1px solid #999', margin: '40px auto'}} />

        {/* Contact Us */}
        <h2>{t.privacy_policy.contact_us.title}</h2>
        <p>{t.privacy_policy.contact_us.description}</p>
        <ul>
          <li>{t.privacy_policy.contact_us.email}</li>
          <li>{t.privacy_policy.contact_us.website}</li>
        </ul>
      </Container>
    </>
  )
}

export default PrivacyPage
